/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./difficulty-card.vue?vue&type=template&id=53301f2a&"
import script from "./difficulty-card.vue?vue&type=script&lang=js&"
export * from "./difficulty-card.vue?vue&type=script&lang=js&"
import style0 from "./difficulty-card.vue?vue&type=style&index=0&id=53301f2a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports